export const FETCH_PROFESSIONS_REQUEST = "FETCH_PROFESSIONS_REQUEST";
export const UPDATE_PROFESSION_REQUEST = "UPDATE_PROFESSION_REQUEST";
export const CREATE_PROFESSION_REQUEST = "CREATE_PROFESSION_REQUEST";
export const CHANGE_PROFESSION_WEIGHT_REQUEST = "CHANGE_PROFESSION_WEIGHT_REQUEST";
